module.exports = __webpack_public_path__ + "static/media/Nøyaktig.c6c71c5c.m4a";